import { OldVariants, Variants } from '@dayetopia/types';

export const getBundleVariant = (variants: Variants | OldVariants | undefined) => {
  if (!variants) return undefined;
  return Object.keys(variants).find((key) => key.includes('_bundle_'));
};
